export type IActivityLevel = "LIGHTLY_ACTIVE" | "ACTIVE" | "VERY_ACTIVE"

export type IGoalTypeName = "WEIGHT_LOSS" | "MAINTAIN" | "BUILDING" | "NOT_SURE"
export type IWeeklyGoal = number

export interface ISetGoalPayload {
  activityLevel: IActivityLevel
  typeName: IGoalTypeName
  weightChangePerWeek?: IWeeklyGoal
  targetWeight?: number
  height: number
  weight: number
}

export interface IOnboardingForm extends ISetGoalPayload {
  weightChangePerWeek: IWeeklyGoal
  targetWeight: number
}

export interface IOnboardingServerPayload {
  type_name: IGoalTypeName
  activity_level: IActivityLevel
  weight_change_per_week: number
  target_weight: number
}

export interface IUserResponse {
  gender: string
  birthedOn: string
  showTutorial: boolean
  showDownload: boolean
  country: string
  paymentSupported: boolean
}
export interface IUser {
  gender: string
  birthedOn: string
  isShowTutorial: boolean
  country: string
  paymentSupported: boolean
}

export interface IResponseGoal {
  caloriePerDay: number
  newCaloriePerDay: null | number
  pfcBalance: {
    carb: number
    fat: number
    protein: number
  }

  pfc: {
    protein: number
    fat: number
    carb: number
  }

  height: number
  weight: number
  targetWeight: number
  weightChangePerWeek: number
  typeName: IGoalTypeName
  reachedOn: string
  bmr: number
  startedAt: string
  showBodyChanged: boolean
  isCustomized?: boolean
  modelMesh: null | {
    measurementMesh: IMesh
    targetMesh: IMesh
  }
}

export interface IMesh {
  axis: number[]
  vertices: number[]
}
export interface IModelMesh {
  measurementMesh: IMesh
  targetMesh: IMesh
}
export interface IGoal {
  caloriesPerDay: number
  newCaloriesPerDay: null | number
  protein: number
  fat: number
  carb: number

  proteinGram: number
  fatGram: number
  carbsGram: number

  height: number
  weight: number
  targetWeight: number
  weightChangePerWeek: number
  typeName: IGoalTypeName
  reachedOn: string
  bmr: number
  startDate: string

  shouldShowWeightChangedNotification: boolean
  isCustomized?: boolean
  modelMesh: null | IModelMesh
}

export interface IOnboardingAPI {
  setGoal: (payload: ISetGoalPayload) => Promise<any>
  getGoal: () => Promise<IResponseGoal>
  getUser: () => Promise<IUserResponse>
  turnOfWeightChangedNotification: () => Promise<any>
}

export interface IOnboardingState {
  onboardingLoading: boolean
  onboardingFailed: any
  onboardingSuccess: any

  getGoalLoading: boolean
  goal?: IGoal
  getGoalFailed: any
  isNotHasGoalYet: boolean

  getUserLoading: boolean
  user?: IUser
  getUserFailed: any
  updatingUser?: IUser

  isTutorialShowed: boolean
  isRevalidatedShouldShowTutorial: boolean
  tutorialBackPath?: string

  shouldShowWeightChangedNotification: boolean
  turnOffWeightChangeNotificationFailed: any
}

export enum ISetGoalStep {
  SetActivityLevel,
  SetTypeName,
  SetTargetWeight,
  ReviewPlan,
}
